import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { JobStatusLabel } from 'components/account/jobs-v2/JobStatusLabel';
const Label = ({ text, color }) => (React.createElement(Text, { style: {
        color,
        textTransform: 'uppercase',
        marginBottom: '10px'
    }, variation: "footnote" }, text));
export const AmlMonitoringStatusBar = ({ status, submittedAt, updatedAt }) => {
    const { gray800 } = useContext(ThemeContext).theme.tokens.colors;
    const { id: jobSid } = useParams();
    return (React.createElement(Box, { display: "flex", flexDirection: ['column', 'row'], flexWrap: "wrap", style: {
            gap: '15px',
            justifyContent: ['center', 'space-around'],
            alignItems: ['flex-start', 'center']
        } },
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Vouched Status" }),
            React.createElement(JobStatusLabel, { hasWarnings: false, status: status })),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Submitted" }),
            React.createElement(Text, null, submittedAt.toLocaleString())),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Updated" }),
            React.createElement(Text, null, updatedAt.toLocaleString())),
        React.createElement(Box, null,
            React.createElement(Label, { color: gray800, text: "Job Id" }),
            React.createElement(Text, null, jobSid))));
};
